import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'ag-common-svc/public-api';
import { DxFormComponent } from 'devextreme-angular';
import { environment } from 'src/environments/environment';
import Validator from 'devextreme/ui/validator';
import { Messages } from 'ag-common-lib/public-api';
import { ToastrService } from 'ngx-toastr';
import { takeSignOutNotice } from 'src/app/shared/services/util/sign-out-notice';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
})
export class LoginFormComponent implements OnInit {
  @ViewChild('signInFormRef', { static: false }) signInFormComponent: DxFormComponent;

  formData: any = {};
  showLoader = false;
  readonly Messages = Messages;

  constructor(
    private authService: AuthService,
    private router: Router,
    private toastrService: ToastrService,
  ) {}

  /**
   * Raises the reason the previous session ended, if there was one. Sign-out reloads
   * the page, so the notice is parked before the reload and read back here rather
   * than shown at the point it was decided, where it would last a few frames.
   */
  ngOnInit(): void {
    const notice = takeSignOutNotice();
    if (!notice) {
      return;
    }

    this.toastrService.error(notice.message, notice.title, {
      enableHtml: true,
      disableTimeOut: true,
    });
  }

  onSubmit = () => {
    const validationResults = this.signInFormComponent.instance.validate();

    if (validationResults?.isValid) {
      this.showLoader = true;
      const { email, password } = this.formData;
      this.authService.signInWithEmailAndPassword(email, password).finally(() => {
        this.showLoader = false;
      });
    }
  };
}
